import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {AuthenticationApiService} from '../../../../projects/api/src/authentication/authentication-api.service';
import {loginPath} from '../../app-routing.constants';
import {LoginPaths} from '../login-paths.enum';
// import {MatSnackBar} from '@angular/material';
import {BehaviorSubject, timer} from 'rxjs';
import {LogoAtommindComponent} from '../../shared/components/logo-atommind/logo-atommind.component';
import {AsyncPipe, NgIf} from '@angular/common';
import {FormatTimeoutPipe} from '../format-timeout.pipe';
import {LoginTextInputComponent} from '../../shared/forms/fields/login-text-input/login-text-input.component';


const TIMEOUT_SEC = 5 * 60;
const TIMER_INTERVAL_MS = 1000;

interface RecoveryPasswordFormModel {
  account: string;
}

@Component({
  selector: 'app-recovery-password-form',
  templateUrl: './recovery-password-form.component.html',
  styleUrls: ['./recovery-password-form.component.scss'],
  standalone: true,
  imports: [
    LogoAtommindComponent,
    ReactiveFormsModule,
    TranslateModule,
    AsyncPipe,
    FormatTimeoutPipe,
    RouterLink,
    NgIf,
    LoginTextInputComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecoveryPasswordFormComponent implements OnInit, OnDestroy {
  public recoveryPasswordForm: FormGroup;
  public blocked$ = new BehaviorSubject<boolean>(false);
  public timeLeft$ = new BehaviorSubject<number>(0);
  public timeout = 0;
  public timer = null;

  login;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private authenticationApiService: AuthenticationApiService,
    private translateService: TranslateService,
    // private snackbar: MatSnackBar
  ) {
    this.createForm();
  }

  ngOnInit() {
    const t = timer(0, TIMER_INTERVAL_MS);
    this.timer = t.subscribe(tick => {
      this.checkTimer();
    });
  }

  ngOnDestroy() {
    this.timer.unsubscribe();
  }

  onSubmit() {
    // this.setBlockUntilTimeout(); // временно убираем блокировку пароля
    this.authenticationApiService.recoveryPassword(this.recoveryPasswordForm.value.account)
      .subscribe(() =>
        // this.snackbar.open(this.translateService.instant('The verification code was sent to your email address'), null, {duration: 2000});
         this.router.navigateByUrl('/' + loginPath + '/' + LoginPaths.loginResetPassword)
      );
  }

  setBlockUntilTimeout(): void {
    this.blocked$.next(true);
    this.timeout = TIMEOUT_SEC;
  }

  checkTimer(): void {
    if (this.timeout <= 0) {
      return;
    }

    this.timeout--;
    this.timeLeft$.next(this.timeout);
    if (this.timeout === 0) {
      this.blocked$.next(false);
    }
  }

  createForm() {
    const form: RecoveryPasswordFormModel = {
      account: ''
    };
    this.recoveryPasswordForm = this.fb.group(form as { [p: string]: any });
  }

}
